import { SVGProps } from 'react';

const Document = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			width="53"
			height="54"
			viewBox="0 0 53 54"
			fill="none"
		>
			<path
				d="M39.1202 22.6406H13.7807C11.725 22.6406 10.0586 24.3071 10.0586 26.3628V39.712C10.0586 41.7677 11.725 43.4341 13.7807 43.4341H39.1202C41.1759 43.4341 42.8423 41.7677 42.8423 39.712V26.3628C42.8423 24.3071 41.1759 22.6406 39.1202 22.6406Z"
				stroke="white"
				strokeWidth="3"
			/>
			<path
				d="M19.222 10.7868L11.7352 10.9141C10.5935 10.9335 9.6837 11.8748 9.70311 13.0165L9.73449 14.8621C9.7539 16.0038 10.6952 16.9136 11.8369 16.8942L19.3237 16.767C20.4654 16.7475 21.3752 15.8063 21.3558 14.6646L21.3244 12.8189C21.305 11.6772 20.3637 10.7674 19.222 10.7868Z"
				stroke="white"
				strokeWidth="3"
			/>
		</svg>
	);
};

export default Document;
